var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteAlpha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.6444913%",
    y1: "24.5881623%",
    x2: "9.71563435%",
    y2: "96.8416405%",
    id: "linearGradient-bg7k__598x-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.10100422,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.55,
    offset: "47.5034487%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location_video_01-copy",
    transform: "translate(-33.000000, -182.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "route-copy",
    transform: "translate(34.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#000000",
    cx: 1.5,
    cy: 12.4444444,
    rx: 1.5,
    ry: 1.55555556
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeOpacity: 0.0954231316,
    stroke: "#000000",
    cx: 10.5,
    cy: 1.55555556,
    rx: 1.5,
    ry: 1.55555556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,12.4444444 L9.375,12.4444444 C10.8247474,12.4444444 11.9999999,11.225664 11.9999999,9.72222222 C11.9999999,8.21878043 10.8247474,7.00000003 9.375,7 L3.375,7 C1.92525253,7 0.75,5.7812196 0.75,4.27777778 C0.75,2.77433596 1.92525253,1.55555556 3.375,1.55555556 L6,1.55555556",
    id: "Path",
    stroke: "url(#linearGradient-bg7k__598x-1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteAlpha);
export default __webpack_public_path__ + "static/media/iconRouteAlpha.20c0978951c44b87313ce0234bb26823.svg";
export { ForwardRef as ReactComponent };